import { render, staticRenderFns } from "./QrConversionRates.vue?vue&type=template&id=9a70f178&scoped=true"
import script from "./QrConversionRates.vue?vue&type=script&lang=js"
export * from "./QrConversionRates.vue?vue&type=script&lang=js"
import style0 from "./QrConversionRates.vue?vue&type=style&index=0&id=9a70f178&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a70f178",
  null
  
)

export default component.exports